import { render, staticRenderFns } from "./sxjhlist.vue?vue&type=template&id=7a2154c6&scoped=true"
import script from "./sxjhlist.vue?vue&type=script&lang=js"
export * from "./sxjhlist.vue?vue&type=script&lang=js"
import style0 from "./sxjhlist.vue?vue&type=style&index=0&id=7a2154c6&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2154c6",
  null
  
)

export default component.exports